/*
export const someMutation = (state) => {}
 */

import { initialState } from './state'
import { notify } from 'src/plugins/notify'
import courses from '../courses'

export default {
  toggleNavDrawer,
  toggleQuickSearch,
  openDetails,
  closeDetails,
  setModule,
  setStates,
  setUserTypes,
  setUserStatuses,
  setSuffixes,
  setDocumentTypes,
  setFileTypes,
  setEntities,
  setOrderTypes,
  setShippingTypes,
  setPaymentMethods,
  setPermissionsList,
  openModal,
  closeModal,
  resetState,
  setOrderStatuses,
}

function toggleNavDrawer (state) {
  state.navDrawer = !state.navDrawer
  window.jQuery(document).trigger('toggleNavDrawer')
}

function toggleQuickSearch (state) {
  state.quickSearch = !state.quickSearch
}

function openDetails (state, { module, mode }) {
  state.detailsModal.module = module
  state.detailsModal.mode = mode
  state.detailsModal.open = true
}

function closeDetails (state) {
  state.detailsModal.open = false
  state.detailsModal.module = ''
  courses.state.selectedTab = 'general'
}

function setModule (state, module) {
  state.detailsModal.module = module
}

function setStates (state, states) {
  state.states = states
}

function setUserTypes (state, userTypes) {
  state.userTypes = userTypes
}

function setUserStatuses (state, userStatuses) {
  state.userStatuses = userStatuses
}

function setPaymentMethods (state, paymentMethods) {
  state.paymentMethods = paymentMethods
}

function setSuffixes (state, suffixes) {
  state.suffixes = [ { label: '', value: ''}, ...suffixes]
}

function setDocumentTypes (state, documentTypes) {
  state.documentTypes = documentTypes
}

function setFileTypes (state, fileTypes) {
  state.fileTypes = fileTypes
}

function setEntities (state, entities) {
  state.entities = entities
}

function setOrderTypes (state, orderTypes) {
  state.orderTypes = orderTypes
}

function setOrderStatuses (state, orderStatuses) {
  state.orderStatuses = orderStatuses
}

function setShippingTypes (state, shippingTypes) {
  state.shippingTypes = shippingTypes
}

function setPermissionsList (state, permissions) {
  state.permissionsList = permissions
}

function openModal(state, modalRoute) {
  
  let route = state[modalRoute + "Modal"]
  if(route !== undefined){
    state[modalRoute + "Modal"] = true
  }
  else{
    notify.create({
      message: "Not Yet Implemented!",
      type: "negative"
    })
  }
}

function closeModal (state, modal) {
  state[modal + "Modal"] = false
}

function resetState (state) {
  // _.each(state, (value, key) => {
  //     state[key] = initialState[key]
  // })
  state = { ...initialState }
}
